/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idnes_LoginInputs */

const cs_idnes_login = /** @type {(inputs: Idnes_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importní login`)
};

const en_idnes_login = /** @type {(inputs: Idnes_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import login`)
};

/**
* | output |
* | --- |
* | "Import login" |
*
* @param {Idnes_LoginInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const idnes_login = /** @type {((inputs?: Idnes_LoginInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idnes_LoginInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_idnes_login(inputs)
	return cs_idnes_login(inputs)
});